import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJOperatorsProcessor } from "../phases/RJOperatorsProcessor";
import { RJLexer } from "../RJLexer";
import { RJParser } from "../RJParser";

export abstract class Operator
{
  tokenType:string|RegExp = "";
  tokenValue:string|RegExp = "";
  _processor:RJOperatorsProcessor;
  _parser:RJParser;

  constructor( parser:RJParser )
  {
    this._parser = parser;
  }

  get processor():RJOperatorsProcessor{ return this._processor };
  

  setProcessor( processor:RJOperatorsProcessor  )
  {
    this._processor = processor;
  }

  setStartToken(  type:string|RegExp, value:string|RegExp )
  {
    this.tokenType = type;
    this.tokenValue = value;
  }

  isFromLeft():boolean
  {
    return true;
  }

  isStartNode( node:RJExpressionNode ):boolean 
  {
    return node.isToken( this.tokenType, this.tokenValue );
  }    

  findStartNodeIndex( nodes:RJExpressionNode[] ):number
  {
    var start     = this.isFromLeft() ? 0 : ( nodes.length - 1);
    var end       = this.isFromLeft() ? nodes.length : -1;

    var step      = this.isFromLeft() ? 1 : -1;

    for ( let i = start; i != end; i += step )
    {
      if ( this.isStartNode( nodes[ i ] ) )
      {
        return i;
      }
    }

    return -1;
  }

  abstract processStartNode( nodes:RJExpressionNode[], index:number ):boolean;
  
  static findClosingBracket( nodes:RJExpressionNode[], index:number ):number
  {
    var startIndex = index;
    var open = 1;

    for ( let i = startIndex + 1; i < nodes.length; i++ )
    {
      if ( nodes[ i ].isToken( RJLexer.BracketOpen ) )
      {
        open ++;
      }

      if ( nodes[ i ].isToken( RJLexer.BracketClose ) )
      {
        open --;

        if ( open == 0 )
        {
          return i;
        }
      }
    }

    return -1;
  }
}